import myzxios from '../utils/myaxios'

export function getDisk(){
    return myzxios({
        url: '/manager/sys-free/get-disk-list',
        method: 'GET'
    })
}